// qiankun 会在运行时注入子应用的真实资源地址。
// 设置 __webpack_public_path__ 后，异步 chunk、图片等资源才能从正确的子应用地址加载。
if (window.__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line no-undef, camelcase
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
}
